// Central AdSense slot config. Create ad units in your AdSense dashboard and drop
// their slot ids here (or via env) to activate each placement. Until a slot id is
// set, that placement renders nothing (Auto Ads still cover the page).
export const AD_SLOTS = {
  homeMid: process.env.REACT_APP_ADSLOT_HOME || "",
  feed: process.env.REACT_APP_ADSLOT_FEED || "",
  articleTop: process.env.REACT_APP_ADSLOT_ARTICLE_TOP || "",
  articleBottom: process.env.REACT_APP_ADSLOT_ARTICLE_BOTTOM || "",
  inContent: process.env.REACT_APP_ADSLOT_INCONTENT || "",
  sidebar: process.env.REACT_APP_ADSLOT_SIDEBAR || "",
};
